import { DISCORD_INVITE_URL } from "@cede/utils";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const BanBanner = () => {
  return (
    <div className="m-2">
      <Alert variant="destructive" className="border-cede-error/60 bg-cede-error/10 text-cede-text-primary">
        <AlertDescription className="text-sm leading-relaxed text-cede-text-primary">
          Your account has been blocked from joining campaigns due to unfair activity (multi-accounting or automated
          tools). If you think this is a mistake, please contact us on{" "}
          <a
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-cede-primary underline"
          >
            Discord
          </a>
        </AlertDescription>
      </Alert>
    </div>
  );
};
